import { BrowserRouter, Route, Routes } from "react-router-dom"
import PageHome from "./pages/PageHome";
import PageMembers from "./pages/PageMembers";
import PageResearch from "./pages/PageResearch";
import PageGallery from "./pages/PageGallery";
import PageJoinUs from "./pages/PageJoinUs";
import PageMember from "./pages/PageMember";
import { PageResearchComp, ResearchImages1, ResearchImages2, ResearchImages3, ResearchImages4 } from "./pages/PageResearchFb";
import PageSignIn from "./pages/PageSignIn";
import PageHomeDB from "./pages/PageHomeDB";

// YU0E9BrFeOrzmAtX
const App = () => {
    return (
        <div>
            <BrowserRouter basename="/">
                <Routes>
                    <Route path="/"                 element={<PageHome />}          />
                    <Route path="/members"          element={<PageMembers />}       />
                    <Route path="/member/:name"     element={<PageMember />}        />
                    <Route path="/research"         element={<PageResearch />}      />
                    <Route path="/research1"        element={
                        <PageResearchComp index='1'><ResearchImages1 /></PageResearchComp>}      
                    />
                    <Route path="/research2"        element={
                        <PageResearchComp index='2'><ResearchImages2 /></PageResearchComp>}      
                    />
                    <Route path="/research3"        element={
                        <PageResearchComp index='3'><ResearchImages3 /></PageResearchComp>}      
                    />
                    <Route path="/research4"        element={
                        <PageResearchComp index='4'><ResearchImages4 /></PageResearchComp>}      
                    />
                    <Route path="/gallery"          element={<PageGallery />}       />
                    <Route path="/joinus"           element={<PageJoinUs />}        />
                    <Route path="/signin"           element={<PageSignIn />}        />
                    <Route path="/homedb"           element={<PageHomeDB />}         />
                </Routes>
            </BrowserRouter>
        </div>
    )
}

export default App;